import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SeoStructuredData from '@/components/base/SeoStructuredData';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import PopularRanking from './components/PopularRanking';
import RecommendSection from './components/RecommendSection';
import Testimonials from './components/Testimonials';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <SeoStructuredData
        type="WebPage"
        data={{
          name: '土豪漫画网 - 免费漫画下拉式 - 高清韩漫人气榜 - 韩国漫画在线观看',
          url: 'http://thinkbu.com/',
          description: '土豪漫画网提供免费漫画下拉式浏览和高清韩漫人气榜，您可以在线观看韩国漫画，轻松追踪热门趋势并享受视觉上的精彩盛宴。',
        }}
      />
      <SeoStructuredData
        type="BreadcrumbList"
        data={{
          items: [{ name: '首页', url: 'http://thinkbu.com/' }],
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <PopularRanking />
        <RecommendSection />
        <Testimonials />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}